export const TICKET_REALTIME = "ticket-realtime";

export function emitTicketRealtime(payload) {
	if (!payload?.ticket) return;
	window.dispatchEvent(
		new CustomEvent(TICKET_REALTIME, {
			detail: payload,
		})
	);
}
